/**
 * This script handles the loyalty program button clicks within the <loyalty-program> custom element.
 * When a button inside .yotpo-customer-logged-out-buttons is clicked, the script updates the URL with the hash #status,
 * triggering the hashchange event to handle the popup display.
 */
class LoyaltyProgram extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('click', this.globalClickHandler.bind(this), true);

    this.truevaultNotice = this.querySelector('[data-truevault-notice]')
    this.checkContentUpdate()
  }

  globalClickHandler(event) {
    if (event.target.matches('.yotpo-customer-logged-out-buttons button')) {
      event.preventDefault();
      event.stopImmediatePropagation();

      window.location.hash = 'status';
    }
  }

  checkContentUpdate() {
    if (!this.truevaultNotice) { return }
    const config = { attributes: false, childList: true, subtree: true };
    const callback = (_, observer) => {
      const wrapper = this.querySelector('#yotpoReferralDescriptionText')
      if (wrapper) {
        this.truevaultNotice.style.display = 'block'
        this.truevaultNotice.style.marginTop = '10px'
        this.truevaultNotice.style.color = '#000'
        this.truevaultNotice.classList.remove('hidden')
        wrapper.append(this.truevaultNotice)
        observer.disconnect()
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(this, config);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.globalClickHandler.bind(this), true);
  }
}

customElements.define('loyalty-program', LoyaltyProgram);